import { useSelector } from 'react-redux';

import { productFeatureDisabled } from 'dashboard/lib/productFeature';
import { ProductFeatureName } from 'dashboard/models/organization';
import { TRIGGER_EVENTS } from 'dashboard/models/trigger';
import { RootState } from 'dashboard/redux/store';
import { EventName } from 'lib/constants/events';

const useWorkflowTriggerableEvents = (): EventName[] => {
  const featureFlags = useSelector((state: RootState) => state.featureFlags.featureFlags);
  const organization = useSelector((state: RootState) => state.organization.organization);
  const currentEnvironment = useSelector(
    (state: RootState) => state.currentEnvironment.currentEnvironment,
  );
  const hasTransactionsDashboard = !productFeatureDisabled(
    organization,
    ProductFeatureName.TransactionsDashboard,
    currentEnvironment.type,
  );

  return TRIGGER_EVENTS.filter((e) => {
    switch (e) {
      case EventName.AccountCreated:
        return featureFlags['dashboard:workflows-account-event'];
      case EventName.AccountStatusUpdated:
        return featureFlags['dashboard:workflows-account-event'];
      case EventName.AccountTagAdded:
      case EventName.AccountTagRemoved:
        return featureFlags['global:enable-account-tags-workflow-event-trigger'];
      case EventName.AccountUpdatedFields:
        return featureFlags['dashboard:accounts-emit-account-updated-field-events-v2'];
      case EventName.TransactionCreated:
      case EventName.TransactionStatusUpdated:
        return hasTransactionsDashboard;
      case EventName.InquiryTemplateVersionCreated:
      case EventName.InquiryTemplateVersionPublished:
        return featureFlags['dashboard:enable-workflows-inquiry-template-version-trigger-events'];
      default:
        return true;
    }
  });
};

export default useWorkflowTriggerableEvents;
